/**
 * Check if tauschbonus can be selected for this device/saleschannel
 */
export function getIsTauschbonusEligible () {
    return (window as any).additionalPageOptions?.promos?.tauschbonus !== undefined;
}
